import type {BioIconProps} from './common-types'

export function IconCopy({...attributes}: BioIconProps) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M21.332 4H5.33197V21.3333"
        stroke="black"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 9.33594H26.666V25.3359C26.666 26.0432 26.385 26.7215 25.8849 27.2216C25.3848 27.7217 24.7065 28.0026 23.9993 28.0026H13.3326C12.6254 28.0026 11.9471 27.7217 11.447 27.2216C10.9469 26.7215 10.666 26.0432 10.666 25.3359V9.33594Z"
        stroke="black"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
